import { Tabs } from "@shared/ui/tabs";
import { useNavigate, useParams } from "react-router-dom";
import { RoutesTab } from "./tabs/routesTab/routesTab";
import { PremisesTab } from "./tabs/premisesTab/premisesTab";
import { MetersTab } from "./tabs/metersTab/metersTab";
import { ValidationEstimationsTab } from "./tabs/validationEstimationsTab/validationEstimationsTab";
import { ActivityLogTab } from "@features/mx/shared/components/ActivityLog";
import { NotesTab } from "@features/mx/shared/components/NotesTab";
import RunHistoryTab from "../readCycleRuns/tabs/runHistoryTab/runHistoryTab";
import OverviewTab from "./tabs/overviewTab/overviewTab";

const urlMapping = {
  overview: "overview",
  runHistory: "run-history",
  routes: "routes",
  premises: "premises",
  resources: "resources",
  validationEstimations: "validation-estimations",
  activityLog: "activity-log",
  notes: "notes",
};

export const ReadCycleEntitiesTab = ({ data }: { data: any }) => {
  const { cycle_id } = useParams();
  const source = "2";

  const tabComponents = {
    overview: {
      label: "Overview",
      shortLabel: "Overview",
      component: <OverviewTab readCycleData={data} />,
    },
    runHistory: {
      label: "Runs",
      shortLabel: "Runs",
      component: <RunHistoryTab />,
    },
    routes: {
      label: "Routes",
      shortLabel: "Routes",
      component: <RoutesTab />,
    },
    premises: {
      label: "Premises",
      shortLabel: "Premises",
      component: <PremisesTab readCycleData={data} />,
    },
    resources: {
      label: "Resources",
      shortLabel: "Resources",
      component: <MetersTab />,
    },
    validationEstimations: {
      label: "Validation & Estimations",
      shortLabel: "Validation & Estimations",
      component: <ValidationEstimationsTab readCycleData={data} />,
    },
    notes: {
      label: "Notes",
      component: (
        <NotesTab requestId={cycle_id} source={source} title="System" />
      ),
    },
    activityLog: {
      label: "Activity Log",
      shortLabel: "Activity Log",
      component: <ActivityLogTab entityId={cycle_id} entityType={source} />,
    },
  };

  return (
    <div>
      <Tabs
        defaultValue="overview"
        urlMapping={urlMapping}
        tabComponents={tabComponents}
        tabsListClassName="grid w-full grid-cols-8 mb-6"
        idPrefix="readCycle-tab"
        level={1}
      />
    </div>
  );
};
